import { createSlice } from "@reduxjs/toolkit";

const initialLayoutState = {
  chat: {
    individual: {
      isDisplay: false,
    },
    general: {
      isDisplay: false,
    },
    group: {
      isDisplay: false,
    },
  },
  questionAnswer: {
    isDisplay: false,
  },
};

const layout = createSlice({
  name: "layout",
  initialState: initialLayoutState,
  reducers: {
    chatSectionController: (state, action) => {
      const chatType = action.payload;
      state.chat[chatType].isDisplay = !state.chat[chatType].isDisplay;
      for (const type in state.chat) {
        if (type !== chatType) {
          state.chat[type].isDisplay = false;
        }
      }
    },
    chatSectionResetController: (state) => {
      for (const type in state.chat) {
        state.chat[type].isDisplay = false;
      }
    },
    questionAnswerController: (state) => {
      state.questionAnswer.isDisplay = !state.questionAnswer.isDisplay;
      for (const type in state.chat) {
        state.chat[type].isDisplay = false;
      }
    },
  },
});

export const {
  chatSectionController,
  chatSectionResetController,
  questionAnswerController,
} = layout.actions;

export default layout.reducer;
